import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=3289e4eb"
import script from "./Terms.vue?vue&type=script&lang=js"
export * from "./Terms.vue?vue&type=script&lang=js"
import style0 from "./Terms.vue?vue&type=style&index=0&id=3289e4eb&prod&lang=css"
import style1 from "./Terms.vue?vue&type=style&index=1&id=3289e4eb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports